import * as actions from "../Constants/actionTypes";
import { AlertError } from "../../Utils/alertUtils";

const initState = {
    isLoading: false,
    data: [],
};

const myReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.AT_GET_SEVEN_STAGE_SWING_LIBRARY_CATEGORY_REQUEST: {
            return {
                ...state,
                isLoading: true,
                data: initState.data
            };
        }
        case actions.AT_GET_SEVEN_STAGE_SWING_LIBRARY_CATEGORY_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                data: action.payload
            };
        }
        case actions.AT_GET_SEVEN_STAGE_SWING_LIBRARY_CATEGORY_FAILURE: {
            const { error } = action.payload;
            AlertError(error);
            return {
                ...state,
                isLoading: false,
                data: initState.data
            };
        }
        default:
            return state;
    }
};

export default myReducer;
